import type { IWarehouse } from '@/interfaces'

export class Warehouse implements IWarehouse {
	code: string | null
	name: string | null

	constructor({ code = null, name = null }: Partial<IWarehouse> = {}) {
		this.code = code
		this.name = name
	}
}
